import { isWixDomain } from './isWixDomain';

// Reversed at runtime, so the fallback target is not a plain-text search hit in the bundle.
const FALLBACK_URL_REVERSED = 'setalpmet/etisbew/moc.xiw.www//:sptth';

const getFallbackURL = () => FALLBACK_URL_REVERSED.split('').reverse().join('');

const isWixHttpsURL = (url: URL) =>
  url.protocol === 'https:' && (url.hostname === 'wix.com' || url.hostname.endsWith('.wix.com'));

const getTarget = (baseURL: string) => {
  try {
    const url = new URL(baseURL);
    return isWixHttpsURL(url) ? url.href : getFallbackURL();
  } catch (_) {
    return getFallbackURL();
  }
};

// Proxy clones serve our HTML under their own host. Send the visitor to the real page.
// baseURL comes from that HTML, so a proxy can change it; a non-Wix value falls back to a fixed target.
// location.replace, because clones patch the History API to keep their own origin.
export function redirectFromForeignHost(baseURL: string) {
  if (isWixDomain(window.location.hostname)) {
    return;
  }
  window.location.replace(getTarget(baseURL));
}
